var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.045 21.045C27.1503 22.079 24.9771 22.6667 22.6667 22.6667C15.3029 22.6667 9.33333 16.6971 9.33333 9.33335C9.33333 7.02288 9.92101 4.84967 10.955 2.95505C6.8112 5.21661 4 9.61335 4 14.6667C4 22.0305 9.96954 28 17.3333 28C22.3867 28 26.7834 25.1888 29.045 21.045Z",
    fill: "#0A335C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 0C20.6668 0 21.0714 3.77662 22.6475 5.35267C24.2235 6.92871 28.0002 7.33333 28.0002 7.33333C28.0002 7.33333 24.2235 7.73795 22.6475 9.314C21.0714 10.89 20.6668 14.6667 20.6668 14.6667C20.6668 14.6667 20.2622 10.89 18.6862 9.314C17.1101 7.73795 13.3335 7.33333 13.3335 7.33333C13.3335 7.33333 17.1101 6.92872 18.6862 5.35267C20.2622 3.77662 20.6668 0 20.6668 0Z",
    fill: "#73EFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10.6667C28 10.6667 28.2207 12.7266 29.0804 13.5863C29.94 14.446 32 14.6667 32 14.6667C32 14.6667 29.94 14.8874 29.0804 15.747C28.2207 16.6067 28 18.6667 28 18.6667C28 18.6667 27.7793 16.6067 26.9196 15.747C26.06 14.8874 24 14.6667 24 14.6667C24 14.6667 26.06 14.446 26.9196 13.5863C27.7793 12.7266 28 10.6667 28 10.6667Z",
    fill: "#73EFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark_mode.623e66fd93bf8e317b1d7c4e1610cf3c.svg";
export { ForwardRef as ReactComponent };